/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
export { StringsReplaceFormBase as StringsReplaceForm } from './StringsReplaceForm.base.js'
